import type { FC, ReactElement } from 'react';

import { Bets } from '../../config/bets';
import { useHighflyerStateSlice } from '../../store/slices/highflyerState/selectors';
import { CrashTrafficLightConnected } from '../trafficLight/CrashTrafficLightConnected';

import { FloatingBetMultiplier } from './FloatingBetMultiplier';
import { FloatingBetStatusConnected } from './FloatingBetStatusConnected';

import styles from './FloatingBetControls.module.css';

interface FloatingBetControlProps {}
export const FloatingBetControls: FC<FloatingBetControlProps> = (): ReactElement => {
  const isMultiplier = useHighflyerStateSlice.getMultiplier();

  return (
    <div className={styles.floating_bet_control}>
      <div className={styles.floating_progress_bar}>
        {isMultiplier ? <FloatingBetMultiplier /> : <CrashTrafficLightConnected floatingStatusBar={true} />}
      </div>
      <div className={styles.floating_bet_status_wing}>
        {[Bets.ONE, Bets.TWO].map((betCode) => {
          return <FloatingBetStatusConnected betCode={betCode} key={betCode} />;
        })}
      </div>
    </div>
  );
};
